// extracted by mini-css-extract-plugin
export default {"icon":"ExpandDossierButton_icon__ej3cM","button":"ExpandDossierButton_button__mVip8"};